export default __webpack_public_path__ + "static/media/energy_selected.6b6e5c94.svg";